import { SignUpHeader } from '../../components/SignUpHeader';
import { ProSignUpStep2Form } from '../../components/ProSignUpStep2Form';
import { RedirectIfAuthed } from '../../../lib/use-auth';

export default function ProSignUpStep2Page() {
  return (
    <RedirectIfAuthed>
      <div className="bg-white min-h-screen flex flex-col">
        <SignUpHeader mode="signin" isProfessional={true} />

        <main className="flex-1 flex flex-col items-center justify-center py-6 md:py-12 px-4 w-full">
          <ProSignUpStep2Form />
        </main>
      </div>
    </RedirectIfAuthed>
  );
}
